import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=d4b2acca&scoped=true"
import script from "./AudioUpload.vue?vue&type=script&lang=js"
export * from "./AudioUpload.vue?vue&type=script&lang=js"
import style0 from "./AudioUpload.vue?vue&type=style&index=0&id=d4b2acca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b2acca",
  null
  
)

export default component.exports